module.exports = __webpack_public_path__ + "2bb8f96f8020918acf2128caabbd0f58.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/images/rs6/bank4.png
// module id = 1081
// module chunks = 0